import { AxiosResponse, AxiosRequestConfig } from 'axios'
import * as qs from 'query-string'

import { accidentsApi } from '.'

import { File } from '../interfaces/File.interface'
import { ClaimInvoice } from '../interfaces/ClaimInvoice.interface'

export const getInvoices = () => {
  return accidentsApi.get('/invoice')
    .then((response: AxiosResponse) => response.data)
}

export const getInvoice = (invoiceId: number|string) => {
  return accidentsApi.get<ClaimInvoice>(`/invoice/${invoiceId}`)
    .then((response: AxiosResponse) => response.data)
}

export const createInvoice = (claimIds: number[]) => {
  return accidentsApi.post('/invoice', { claimIds })
    .then((response: AxiosResponse) => response.data)
}

export const uploadInvoiceFile = (invoiceId: number|string, file: any) => {
  const formData = new FormData()
  formData.append('file', file)

  return accidentsApi.post(`/invoice/${invoiceId}/files`, formData)
    .then((response: AxiosResponse) => response.data)
}

export const getInvoiceFiles = (invoiceId: number|string) => {
  return accidentsApi.get<File>(`/invoice/${invoiceId}/files`)
    .then((response: AxiosResponse) => response.data)
}

export const updateInvoice = (invoiceId: string, payload: any) => {
  return accidentsApi.post(`/invoice/${invoiceId}`, payload)
    .then((response: AxiosResponse) => response.data)
}

export const payInvoice = (invoiceId: number|string, payload: any) => (
  accidentsApi.post<ClaimInvoice>(`/invoice/${invoiceId}/pay`, payload)
    .then((response: AxiosResponse) => response.data)
)

export const deleteInvoice = (invoiceId: number|string) => (
  accidentsApi.delete(`/invoice/${invoiceId}`)
    .then((response: AxiosResponse) => response.data)
)


// WEBPACK FOOTER //
// ./src/lib/api/invoices.ts